export const getLanguageFromLocale = (country: string) => (country?.includes('-') ? country?.split('-')[0] : country);
